import '../assets/styles/header.scss';
import { Link, NavLink } from 'react-router-dom';
import { useEffect, useState } from 'react';

function ExternalIcon() {
  return (
    <svg className="ext-icon" width={10} height={10} fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 12 12" aria-hidden="true">
      <path d="M10.976 1.193A.314.314 0 0010.687 1H6.312a.313.313 0 000 .625h3.62L5.467 6.091a.313.313 0 00.443.442l4.466-4.466v3.62a.313.313 0 00.625 0V1.313a.328.328 0 00-.024-.119z" />
      <path d="M3.5 1v.625H2.25a.625.625 0 00-.625.625v7.5c0 .345.28.625.625.625h7.5c.345 0 .625-.28.625-.625V8.5H11v1.875c0 .345-.28.625-.625.625h-8.75A.625.625 0 011 10.375v-8.75C1 1.28 1.28 1 1.625 1H3.5z" />
    </svg>
  );
}

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  return (
    <>
      <header id="main-header" className={scrolled ? 'scrolled' : ''}>
        <div className="header-inner wd-8">
          {/* Logo */}
          <Link to="/" aria-label="Home">
            <img
              className="logo w-50"
              src={require('./../assets/images/pius.svg').default}
              alt="PIUS"
            />
          </Link>

          {/* Desktop nav */}
          <ul className="nav__links d-none d-md-flex">
            <li>
              <NavLink to="/projects" className={({ isActive }) => isActive ? 'active' : ''}>
                Projects
              </NavLink>
            </li>
            <li>
              <a href="https://pye.hashnode.dev/" target="_blank" rel="noreferrer">
                Blog <ExternalIcon />
              </a>
            </li>
            <li>
              <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>
                Contact
              </NavLink>
            </li>
          </ul>

          {/* Mobile hamburger */}
          <button
            className="mobile-menu-btn d-md-none"
            onClick={() => setMobileOpen(true)}
            aria-label="Open menu"
          >
            <img src={require('./../assets/images/open_menu.svg').default} alt="" aria-hidden="true" />
          </button>
        </div>
      </header>

      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="mobile-overlay"
          onClick={() => setMobileOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Navigation menu"
        >
          <div className="mobile-nav" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-nav-header">
              <Link to="/" onClick={() => setMobileOpen(false)}>
                <img
                  src={require('./../assets/images/pius.svg').default}
                  alt="PIUS"
                  style={{ height: '1.5rem' }}
                />
              </Link>
              <button
                className="mobile-close"
                onClick={() => setMobileOpen(false)}
                aria-label="Close menu"
              >
                <img src={require('./../assets/images/close.svg').default} alt="" aria-hidden="true" />
              </button>
            </div>

            <ul className="mobile-nav-links">
              <li>
                <NavLink
                  to="/projects"
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={() => setMobileOpen(false)}
                >
                  Projects
                </NavLink>
              </li>
              <li>
                <a href="https://pye.hashnode.dev/" target="_blank" rel="noreferrer" onClick={() => setMobileOpen(false)}>
                  Blog
                </a>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  className={({ isActive }) => isActive ? 'active' : ''}
                  onClick={() => setMobileOpen(false)}
                >
                  Contact
                </NavLink>
              </li>
            </ul>

            <p className="mobile-nav-footer">Product Engineer — Lagos</p>
          </div>
        </div>
      )}
    </>
  );
}

export default Header;
